import { UserNameCell } from "@/components";
import { User } from "@/types";
import { formatDate, formatUserRoleToName } from "@/utils";
import { FC } from "react";
import {
  Datagrid,
  FunctionField,
  List,
  Pagination,
  TextField,
} from "react-admin";
import { useGetSubscriptionPlans } from "../../queries";
import { ActionField } from "../action-field";
import { StatusField } from "../status-field";
import { TopToolbar } from "../top-toolbar";

const UsersList: FC = () => {
  useGetSubscriptionPlans();

  return (
    <List<User>
      perPage={30}
      actions={<TopToolbar />}
      pagination={<Pagination rowsPerPageOptions={[10, 15, 30, 50]} />}
      sort={{ field: "createdAt", order: "ASC" }}
      empty={<></>} // needn't empty list component
    >
      <Datagrid
        bulkActionButtons={false}
        style={{ tableLayout: "fixed" }}
        rowClick={"show"}
      >
        <UserNameCell
          label="Name"
          source="id"
          sortBy="firstName"
          sortable={true}
        />
        <TextField<User>
          noWrap
          label="Email"
          source="email"
          style={{ display: "block" }}
          sortable={false}
        />
        <FunctionField<User>
          label="Role"
          sortable={false}
          render={({ role }) => formatUserRoleToName(role)}
        />
        <FunctionField<User>
          label="Member since"
          source="createdAt"
          render={({ createdAt }) => formatDate(createdAt)}
        />
        <FunctionField<User>
          label="Last active"
          source="lastSeen"
          render={({ lastSeen }) => formatDate(lastSeen)}
        />
        <StatusField label="Status" source="" sortable={false} />
        <FunctionField<User>
          label="Referrers"
          source=""
          render={({ referralRequests }) =>
            referralRequests?.length
              ? `${referralRequests[0].referrer.firstName ?? ""} ${
                  referralRequests[0].referrer.lastName ?? ""
                }${referralRequests.length > 1 ? ", etс..." : ""}`
              : "—"
          }
        />
        <ActionField sortable={false} />
      </Datagrid>
    </List>
  );
};

export { UsersList };
